var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSlideshare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2911_11171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6643 12.0078C12.008 12.0078 9.84394 14.0156 9.84394 16.5156C9.84394 18.9922 12.008 21.0234 14.6643 21.0234C17.3205 21.0234 19.4846 18.9922 19.4846 16.5156C19.4846 14.0156 17.3205 12.0078 14.6643 12.0078ZM25.8674 12.0078C23.2111 12.0078 21.0471 14.0156 21.0471 16.5156C21.0471 18.9922 23.2111 21.0234 25.8674 21.0234C28.5471 21.0234 30.6877 18.9922 30.6877 16.5156C30.6955 14.0156 28.5471 12.0078 25.8674 12.0078ZM38.1018 19.0391L37.633 19.375V3.88281C37.633 1.74219 36.0236 0 34.0393 0H5.98457C4.00019 0 2.39082 1.74219 2.39082 3.88281V19.375C2.23457 19.2656 2.05488 19.1484 1.89863 19.0391C0.718943 18.2109 -0.0623071 19.3516 0.64863 20.4219C2.07832 22.1875 4.79707 24.3516 8.95332 26.0469C4.55488 41.0234 19.6877 43.4141 19.4455 35.7422C19.4455 35.6875 19.4689 31.3203 19.4689 28.1953C19.8674 28.2812 20.2033 28.375 20.5393 28.4375C20.5393 31.5391 20.5627 35.6875 20.5627 35.7422C20.3205 43.4219 35.4533 41.0312 31.0549 26.0547C35.2033 24.3594 37.9299 22.1953 39.3596 20.4297C40.0705 19.3516 39.2893 18.2187 38.1018 19.0391ZM35.7189 20.5391C30.3361 23.4609 25.6955 22.9688 23.1721 22.8594C21.3205 22.7891 20.6252 23.5703 20.5393 24.8047C19.7346 24.2031 19.0861 23.5937 18.9533 23.4687C18.5549 23.0469 17.883 22.8438 16.8361 22.8672C14.3596 22.9531 9.82832 23.4453 4.53926 20.6797V5.64844C4.53926 2.92188 5.23457 2.07813 7.71113 2.07813H32.5314C34.8986 2.07813 35.7268 3.08594 35.7268 5.64844V20.5391H35.7189Z",
    fill: "#0D216D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2911_11171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSlideshare);
export default __webpack_public_path__ + "static/media/ic-slideshare.aab3f791b666d7cfdc0082a8c4732dd0.svg";
export { ForwardRef as ReactComponent };